// extracted by mini-css-extract-plugin
export default {"container":"TopicsHeader_container__+BrkI","actions__container":"TopicsHeader_actions__container__p6qId","query__input":"TopicsHeader_query__input__7W7YI"};